var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('svg',{staticClass:"ind-icon ind-icon_expand",class:{ clicked: _vm.isClicked },staticStyle:{"color":"white"},on:{"click":_vm.rotation}},[_c('use',{attrs:{"xlink:href":"#arrow-down"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }